import { SharedService } from './../shared.service';
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { ProjectState } from 'src/app/core/models/ProjectState';

@Component({
  standalone: false,
  selector: 'fdb-project-state',
  templateUrl: './project-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./project-state.component.scss']
})
export class ProjectStateComponent implements OnInit {
  
  public UIControlTyp = UIControlTyp;
  public SelectedProjectStateId: number = 0;
  /** Hiremit können Sie das UIControl auf Readonly setzen */
  @Input() readonly = false;
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.ProjectStates.map(unit => Number(unit.id)) :
      Number(this.SelectedProjectStateId || 0);
    return val;
  }
  set values(val: string | number | (string | number)[]) {
    if (Array.isArray(val)) {
      this.ProjectStates = (val as (string | number)[]).map(id => this.getObjectFromList(Number(id)));
      this.getRefreshSelectedValue();
    } else {
      this.SelectedProjectStateId = this.normalizeId(val as string | number);
      this.ProjectState = this.getObjectFromList(this.SelectedProjectStateId);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public ProjectStates: ProjectState[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public ProjectState: ProjectState;
  /** Enthält die Werte die angezeigt werden dürfen */
  public ProjectStateList: ProjectState[] = [];
  /** Enthält die Originalliste mit allen Werten */
  public OriginalValues: ProjectState[] = [];

  constructor(private modulService: SharedService, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.initProjectStates();
  }

  initProjectStates() {
    this.modulService.getProjectState()
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.ProjectStateList = this.OriginalValues.filter(s => s.isActive === true);
          if (this.uiController === UIControlTyp.DropDownList) {
            this.ProjectStateList.unshift(new ProjectState().getEmptyModel());
          }
          this.refreshSelectedValue();
          this.rebindSelectedProjectStateId();
        }
      },
        err => this.modulService.showNotification(err, 'error')
      );
  }

  filterProjectStateList(value: string) {
    this.ProjectStateList = this.OriginalValues
      .filter((s) => (s.name || '').toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(event?: number | (string | number)[]): void {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      if (Array.isArray(event)) {
        this.ProjectStates = event.map(id => this.getObjectFromList(Number(id)));
      }
      this.getRefreshSelectedValue();
    } else {
      this.SelectedProjectStateId = this.normalizeId(event as number);
      this.ProjectState = this.getObjectFromList(this.SelectedProjectStateId);
    }

    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: number): ProjectState {
    if (id === 0) { return new ProjectState().getEmptyModel(); }
    const find = this.OriginalValues.find(unit => unit.id === id);
    return find ? find : new ProjectState().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.ProjectState ? this.ProjectState.id : 0));
    return find ? find.name : '';
  }
  getRefreshSelectedValue() {
    this.ProjectStates = this.ProjectStates
      .map(x => this.OriginalValues.find(y => Number(y.id) === Number(x.id)) || x)
      .filter(x => !!x);
  }

  private refreshSelectedValue() {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.getRefreshSelectedValue();
      return;
    }

    this.ProjectState = this.getObjectFromList(Number(this.ProjectState ? this.ProjectState.id : this.SelectedProjectStateId));
    this.SelectedProjectStateId = Number(this.ProjectState ? this.ProjectState.id : 0);
  }

  private rebindSelectedProjectStateId() {
    const selectedId = Number(this.SelectedProjectStateId || 0);
    this.SelectedProjectStateId = 0;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.SelectedProjectStateId = selectedId;
      this.cdRef.detectChanges();
    });
  }

  private normalizeId(id: string | number): number {
    const parsed = Number(id);
    return isNaN(parsed) ? 0 : parsed;
  }
}
